import { defineMessages } from "@/i18n";
import en from "./en";

export const framesAgendaMessages = defineMessages("frames-agenda", en);
